import React from "react";

const AddIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.75 8.25H16.5V9.75H9.75V16.5H8.25V9.75H1.5V8.25H8.25V1.5H9.75V8.25Z"
        fill="white"
      />
    </svg>
  );
};

export default AddIcon;
